module.exports = __webpack_public_path__ + "img/citi.8d5b4dd2.png";